<script>

    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher()


    let activeOption = 'rent'

    function changeOption() {
        activeOption = activeOption == 'rent' ? 'hike' : 'rent'
        dispatch('option-changed', activeOption)
    }

</script>

<style>

    .gv-switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 16px;
    }

    /* Hide default HTML checkbox */
    .gv-switch input {
    opacity: 0;
    width: 0;
    height: 0;
    }

    /* The slider */
    .gv-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
    }

    .gv-slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 12px;
    left: 4px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
    }

    input:checked + .gv-slider {
    background-color: #ccc;
    }

    input:focus + .gv-slider {
    box-shadow: 0 0 1px black;
    }

    input:checked + .gv-slider:before {
    -webkit-transform: translateX(20px);
    -ms-transform: translateX(20px);
    transform: translateX(20px);
    }

    /* Rounded gv-sliders */
    .gv-slider.round {
    border-radius: 34px;
    }

    .gv-slider.round:before {
    border-radius: 50%;
    }

    .option {
        font-size: 14px;
        /* width: 150px; */
    }

    .active {
        font-weight: 700
    }

    .toggle-label {
        margin-right: 3px;
    }

    .slider-con {
        display: flex;
        align-items: center;
        margin-top: 8px;
        border-top: 1px solid #d9d9d9;
        padding-top: 8px;
    }

    .mr {
        margin-right: 4px;
    }
    .ml {
        margin-left: 4px;
    }

</style>

<div class='slider-con' >
<!-- <span class='toggle-label Option'>Toggle Option: </span> -->
<span class='option mr' class:active={activeOption == 'rent'}>Show rent in 2024</span>
<label class="gv-switch">
    <input type="checkbox" on:click={changeOption}>
    <span class="gv-slider round"></span>
  </label>
<span class='option ml' class:active={activeOption == 'hike'}>Show rise since 2019</span>
</div>
